document.addEventListener('click', function (event) {
  const sizeButton = event.target.closest(
    '.jub-grid-size[data-variant-id]'
  );

  if (!sizeButton) return;
  if (sizeButton.disabled) return;

  event.preventDefault();
  event.stopPropagation();

  const quickAdd = sizeButton.closest(
    '[data-jub-grid-quickadd]'
  );

  if (!quickAdd) return;

  const variantInput = quickAdd.querySelector(
    'input[name="id"]'
  );

  if (!variantInput) return;


  /* Enlève la sélection précédente */

  quickAdd
    .querySelectorAll('.jub-grid-size')
    .forEach(function (button) {
      button.classList.remove('is-selected');
    });


  /* Sélectionne la nouvelle taille */

  sizeButton.classList.add('is-selected');


  /* Modifie l'ID de variante */

  variantInput.value =
    sizeButton.dataset.variantId;


  /* Informe Shopify du changement */

  variantInput.dispatchEvent(
    new Event('change', {
      bubbles: true
    })
  );
});